import { css } from '@emotion/core';
import { variables, tokens } from '@domain-group/fe-brary';
import { designTokenFonts, truncateLines } from '@domain-group/fe-co-allhomes-design-system';
var font = variables.font;
var colors = tokens.colors;
export var features = /*#__PURE__*/css("display:flex;flex-direction:row;align-items:center;gap:8px;color:", colors.neutral.heavy.default, ";margin-top:8px;", designTokenFonts.miniBold);
export var item = {
  name: "ct9q29",
  styles: "display:flex;flex-direction:row;align-items:center;gap:4px;"
};
export var itemValue = {
  name: "rhetjd",
  styles: "padding-top:3px;"
};
export var itemIcon = {
  name: "uk6cul",
  styles: "vertical-align:middle;"
};
export var typeSizeIcon = {
  name: "1v994a0",
  styles: "margin-right:6px;"
};
export var eerIcon = {
  name: "1qkvt8e",
  styles: "margin-right:2px;"
};
export var eerValue = {
  name: "15fzge",
  styles: "margin-left:4px;"
};
var _ref = {
  name: "dg6k3i",
  styles: "&::before{content:'\\2022';margin-right:8px;}"
};
export var typeSizeValue = hasSeparator => /*#__PURE__*/css(hasSeparator && _ref);
export var sizeValueSup = /*#__PURE__*/css("position:relative;top:-0.5em;font-size:", font.smallFontSize, ";");
export var type = /*#__PURE__*/css(truncateLines(1), " overflow-wrap:anywhere;padding-top:3px;");